const CurvedArrowLeft = () => (
  <>
    <path
      fill="currentColor"
      d="M4.939 13.539a8.6 8.6 0 0 1 3.17-2.944 8.7 8.7 0 0 1 4.199-1.057 8.7 8.7 0 0 1 4.474 1.213 8.73 8.73 0 0 1 3.245 3.316.6.6 0 0 0 .314.276.43.43 0 0 0 .388-.024.46.46 0 0 0 .253-.315.56.56 0 0 0-.053-.408 9.8 9.8 0 0 0-3.61-3.706 9.64 9.64 0 0 0-4.992-1.352A9.55 9.55 0 0 0 7.832 9.64 9.7 9.7 0 0 0 4.35 12.7V8.961a.48.48 0 0 0-.143-.356.48.48 0 0 0-.357-.144.48.48 0 0 0-.357.144.48.48 0 0 0-.143.356v4.77a.784.784 0 0 0 .808.808h4.769a.48.48 0 0 0 .357-.144.48.48 0 0 0 .143-.356.48.48 0 0 0-.143-.357.48.48 0 0 0-.357-.143z"
    />
  </>
)
export default CurvedArrowLeft
